module.exports = __webpack_public_path__ + "yeni elit vizyon banyo 2.jpg?83c03406444ea25e8fb44a593ff45176";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni elit vizyon banyo 2.jpg
// module id = 381
// module chunks = 0